import { GET_PENDING_TRANSACTIONS_QUERY_KEY } from "../../queries/useGetPendingTransactions";
import { GET_IN_PROGRESS_TRANSACTIONS_QUERY_KEY } from "../../queries/useGetInProgressTransactions";

const stripTransaction = (transactionId) => (old) => {
  if (!old?.transactions) return old;
  const transactions = old.transactions.filter(
    (tx) => tx.transaction_id !== transactionId,
  );
  if (transactions.length === old.transactions.length) return old;
  const total = old.pagination?.total_results;
  return {
    ...old,
    transactions,
    pagination: old.pagination
      ? {
          ...old.pagination,
          ...(typeof total === "number"
            ? { total_results: Math.max(0, total - 1) }
            : {}),
        }
      : old.pagination,
  };
};

/**
 * Optimistically drop a row from Pending + In Progress caches.
 * Returns snapshots so the caller can roll back on API failure.
 */
export const removeTransactionFromActiveWithdrawalCaches = (
  queryClient,
  transactionId,
) => {
  const previous = {
    pending: queryClient.getQueriesData({
      queryKey: [GET_PENDING_TRANSACTIONS_QUERY_KEY],
    }),
    inProgress: queryClient.getQueriesData({
      queryKey: [GET_IN_PROGRESS_TRANSACTIONS_QUERY_KEY],
    }),
  };

  const strip = stripTransaction(transactionId);
  queryClient.setQueriesData(
    { queryKey: [GET_PENDING_TRANSACTIONS_QUERY_KEY] },
    strip,
  );
  queryClient.setQueriesData(
    { queryKey: [GET_IN_PROGRESS_TRANSACTIONS_QUERY_KEY] },
    strip,
  );

  return previous;
};

export const restoreWithdrawalCacheSnapshots = (queryClient, previous) => {
  previous?.pending?.forEach(([queryKey, data]) => {
    queryClient.setQueryData(queryKey, data);
  });
  previous?.inProgress?.forEach(([queryKey, data]) => {
    queryClient.setQueryData(queryKey, data);
  });
};
